import React from 'react';
import PropTypes from 'prop-types';
import { EmailIcon } from '@domain-group/fe-co-icon';
import { useSendEvent, withEventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import { Button, CallButton, LinkButton } from '@domain-group/fe-co-allhomes-design-system';
import { AllhomesNonEuUser } from '@domain-group/fe-co-allhomes-eu-user';
import * as styles from './mobile-enquiry-cta.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var MobileEnquiryCTA = props => {
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var onEmailClick = () => {
    sendEvent('email-click');
    props.onEmailClick();
  };
  return ___EmotionJSX("div", {
    css: styles.mobileCTA
  }, props.phone && ___EmotionJSX(CallButton, {
    css: styles.callButton(!!props.applyOnlineLink),
    phone: props.phone
  }), ___EmotionJSX(AllhomesNonEuUser, null, ___EmotionJSX(Button, {
    icon: ___EmotionJSX(EmailIcon, null),
    onClick: onEmailClick
  }, "Email")), props.applyOnlineLink && ___EmotionJSX(LinkButton, {
    css: styles.applyButton,
    appearance: "outline",
    href: props.applyOnlineLink,
    onClick: () => sendEvent('apply-online-click'),
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Apply"));
};
MobileEnquiryCTA.propTypes = {
  onEmailClick: PropTypes.func,
  phone: PropTypes.string,
  applyOnlineLink: PropTypes.string
};
MobileEnquiryCTA.defaultProps = {
  phone: null,
  applyOnlineLink: null,
  onEmailClick: () => {}
};
export default withEventBoundary('mobile-enquiry-cta')(MobileEnquiryCTA);